import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BaseApi } from '../laas/base-api.service';
import { environment as ENV } from '../../environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ApplicantService } from 'app/laas/applicant.service';
import { map } from 'rxjs/operators';

@Injectable()
export class AdminAuthService {

  admin: any;
  adminId: string;
  storeStaffId: any;
  private _accessToken: string = null;
  private _authReadyResolve: () => void;
  private _authReadyPromise: Promise<void>;
  private _loginChannel: BroadcastChannel = null;
  private _kickedByOtherTab: boolean = false;

  private companyUrl = '/login';

  constructor(
    private snackbar: MatSnackBar,
    private api: BaseApi,
    public jwtHelper: JwtHelperService,
    public applicant: ApplicantService
  ) {
    var self = this;
    // Auth ready promise - resolves when token is available after refresh, or immediately if not logged in
    this._authReadyPromise = new Promise<void>(function (resolve) {
      self._authReadyResolve = resolve;
      // If not logged in, resolve immediately - no token refresh needed
      if (!self.adminLoggedIn()) {
        resolve();
      }
    });

    // BroadcastChannel for single-tab enforcement
    if (typeof BroadcastChannel !== 'undefined') {
      this._loginChannel = new BroadcastChannel('app_login_channel');
    }
  }

  isKickedByOtherTab(): boolean {
    return this._kickedByOtherTab;
  }

  broadcastNewLogin() {
    // Write to localStorage so other tabs can detect it synchronously
    localStorage.setItem('app_login_event', Date.now().toString());
    if (this._loginChannel) {
      this._loginChannel.postMessage({ type: 'NEW_LOGIN' });
    }
  }

  onLoginFromOtherTab(callback: () => void) {
    var self = this;
    // Listen via storage event (fires synchronously on other tabs when localStorage changes)
    window.addEventListener('storage', function (event) {
      if (event.key === 'app_login_event' && event.newValue) {
        self._kickedByOtherTab = true;
        callback();
      }
    });
    // Also listen via BroadcastChannel as backup
    if (this._loginChannel) {
      this._loginChannel.onmessage = function (event) {
        if (event.data && event.data.type === 'NEW_LOGIN') {
          self._kickedByOtherTab = true;
          callback();
        }
      };
    }
  }

  whenAuthReady(): Promise<void> {
    return this._authReadyPromise;
  }

  resolveAuthReady() {
    if (this._authReadyResolve) {
      this._authReadyResolve();
    }
  }

  getAccessToken(): string {
    return this._accessToken;
  }

  setAccessToken(accessToken: string) {
    this._accessToken = accessToken;
  }

  // Clear local session only (no logout API call) - used for SESSION_EXPIRED
  clearSession() {
    this.admin = null;
    this._accessToken = null;
    sessionStorage.clear();
  }

  // Full logout - calls logout API then clears session
  adminLogout() {
    this.admin = null;
    this._accessToken = null;
    sessionStorage.clear();
  }

  adminLoggedIn() {
    return sessionStorage.getItem('wl-session-active') === 'true';
  }

  cbsStatus(){
    let sentcbsStatus = false
    this.applicant.getCbsStatus().subscribe(resp => {
      console.log(resp, "resp from laas auth guard")
      if (resp && resp.success) {
        if((resp && resp.result && resp.result[ENV.cbsStatusFormat]) || (resp && resp.result && resp.result.sent_to_cbs_date) || (resp && resp.result && resp.result.sent_to_cbs_id)){
          sentcbsStatus = true
        }else{
          
        }
      }
    })

  }

  getRole() {
    const token = sessionStorage.getItem('HicFCyC7V0mJYg3Yw2BBOQ');
    return this.jwtHelper.decodeToken(token)
  }

  private storeAdmin(admin) {
    sessionStorage.setItem('wl-admin-id', admin.id);
    sessionStorage.setItem('userName', admin.userName);
    sessionStorage.setItem('staffId',admin.staffId)
    this.admin = admin;
    this.adminId = admin.id;
    sessionStorage.setItem('branch_code',admin.branch_code)
    sessionStorage.setItem('ro_code',admin.ro_code)
    sessionStorage.setItem('zonal_code',admin.zone_code)

    sessionStorage.setItem('branch_name',admin.branch_name)
    sessionStorage.setItem('ro_name',admin.ro_name)
    sessionStorage.setItem('zone_name',admin.zone_name)
    sessionStorage.setItem('getRoleId',admin.roleId)
    sessionStorage.setItem('approvalStage', admin.approvalStage || '')
  }

  adminLogin(staffId, badWord, mobileNo) {
    console.log("login payload is",staffId,badWord, mobileNo );

    return this.api.newPost(`${this.companyUrl}/login`, { staffId: staffId, prd: badWord, isMobile:false, mobileNo })
      .pipe(map(admin => {
        console.log('Admin Login Data: ', admin);
        return admin;
      }));
  }

  finalizeLogin(admin) {
    if (!admin.roleId) {
      this.storeAdmin(admin);
      let encoded = btoa(ENV.someRandomString.alpha);
      this.storeAccess(encoded);
      if (admin.accessToken) this.setAccessToken(admin.accessToken);
      sessionStorage.setItem('wl-session-active', 'true');
    } else if (admin.roleId && admin.roleId > 0 && (admin.status == 1 || admin.status == 0)) {
      this.storeAdmin(admin);
      let encoded = btoa(ENV.someRandomString.beta);
      this.storeAccess(encoded);
      if (admin.accessToken) this.setAccessToken(admin.accessToken);
      sessionStorage.setItem('wl-session-active', 'true');
    } else {
      this.snackbar.open('Your Login Credentials are disabled. Please Contact Administrator', 'OK', { duration: 3000 });
    }
  }

  updatePasswordWithCheck(userName, newPassword){
    return this.api.postRes(`${this.companyUrl}/updPdWithCheck`, { userName: userName, newPassword: newPassword })
    .pipe(map(check => {
      return check;
    }));
  }

  updatepassword(badWord, oldpass, id) {
    return this.api.postRes(`${this.companyUrl}/updatepass`, { prd: badWord, id: id, oldpass: oldpass })
      .pipe(map(admin => {


        return admin;
      }));
  }

  private storeAccess(acc) {
    sessionStorage.setItem('Wf6gjgGFYJghjg7', acc);
  }

  checkAccess() {
    let role = sessionStorage.getItem('Wf6gjgGFYJghjg7') ? sessionStorage.getItem('Wf6gjgGFYJghjg7') : 'SDSDSD';
    let decoded = atob(role);
    if (decoded == ENV.someRandomString.alpha) {
      return 1;
    } else if (decoded = ENV.someRandomString.beta) {
      return 2;
    } else {
      return 3;
    }
  }

  getCname() {
    return sessionStorage.getItem('cName');
  }

  requestOtp(staffId) {
    return this.api.postRes(`/blg/resetpassword`, staffId )
      .pipe(map(resp => {
        console.log("req otp resp in service " + JSON.stringify(resp));
        return resp;
      }))
  }

  verifyOtp(mobileNo, otp) {
    return this.api.postRes(`${this.companyUrl}/verifyOtp`, { mobileNo: mobileNo, otp: otp }).pipe(map(resp => {
        console.log("verify otp resp in service " + JSON.stringify(resp));
        return resp;
      }))
  }

  verifyUserOtp(value) {
    return this.api.postRes(`/blg/verifyOtp`, value)
      .pipe(map(resp => {
        console.log("verify otp resp in service " + JSON.stringify(resp));
        return resp;
      }))
  }

  setNewPassword(value) {
    return this.api.postRes(`/blg/updPdWithCheck`,value)
      .pipe(map(resp => {
        return resp;
      }))
  }

  getRoleId(){
   return sessionStorage.getItem('getroleId');
  }

  refreshToken() {
    return this.api.postRes('/login/getnewtoken', {}).pipe(
      map(res => {
        var token = res && (res.access_token || res.accessToken);
        if (token) {
          this.setAccessToken(token);
        }
        return res;
      })
    );
  }

  logoutFromServer(userId: string) {
    return this.api.newPost('/login/logout', { id: userId }, true);
  }

  requestUnlock(staffId: string) {
    return this.api.newPost('/login/requestUnlock', { staffId }, true);
  }

  verifyUnlockOtp(staffId: any, otp: string) {
    return this.api.newPost('/login/verifyUnlockOtp', { staffId, otp }, true);
  }

  getStaleUsersReport() {
    return this.api.newGet('/login/admin/staleUsersReport');
  }

  getStaleUsersReportFiltered(payload: any) {
    const filterPayload = {
      state: payload.state || '',
      zonal_code: payload.zone || '',
      ro_code: payload.region || '',
      branch_code: payload.branch || '',
    };
    return this.api.newGet('/login/admin/staleUsersReport', filterPayload);
  }

  generateUserOtp(staffId: any){
    return this.api.newPost('/users/generateuserotp', { staffId }, true);
  }

  verifyuserotp(staffId: any, otp: string){
    return this.api.newPost('/users/verifyuserotp', { staffId, otp }, true);
  }

  terminateSession(applicantId: any) {
    console.log("payload for terminate session: ", applicantId );

    return this.api.newPost('/login/terminateSession', { applicantId }, true).pipe(
      map(res => {
        var token = res && (res.access_token || res.accessToken);
        if (token) {
          this.setAccessToken(token);
        }
        return res;
      })
    );
  }
}
